export default __webpack_public_path__ + "static/media/india.2a6d072c.mp3";